import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit, Input, ChangeDetectorRef } from '@angular/core';
import { FrontService } from '../../front.service';
import { Menu } from '../../../models/menu.model';
import { MasterService } from '../../../services/master.service';
import { Master } from '../../../models/master.model';
import { Subscription } from 'rxjs/Subscription';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TemplateService } from '../../../services/template.service';
import { Template } from '../../../models/template.model';
import { Router } from '@angular/router';
import { Auth } from '../../../models/auth.model';

import * as moment from 'moment';
import { ClientService } from '../../../services/client.service';
import { Client } from '../../../models/client.model';
import { Element } from '../../../models/element.model';
import { SubgroupService } from '../../../services/subgroup.service';
import { Subgroup } from '../../../models/subgroup.model';
import { empty } from 'rxjs/observable/empty';
import { VaultService } from '../../../services/vault.service';
import { Subject } from 'rxjs';
import { CampaignService } from '../../../services/campaign.service';
import { GlobalService } from '../../../services/global.service';
import { DomainService } from '../../../services/domain.service';
import { MyDesktopService } from '../../../services/mydesktop.service';
declare var _bugHerd: any;

declare var jquery: any;
declare var $: any;
declare var swal: any;
declare var introJs: any;

@Component({
  selector: 'app-template-front-dashboard',
  templateUrl: './template-front-dashboard.component.html',
  styleUrls: ['./template-front-dashboard.component.css'],
})
export class TemplateFrontDashboardComponent implements OnInit, OnDestroy, AfterViewInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  ID: number;
  loading = false;
  menus: Menu[] = [];

  master: Master;
  masters: Master[] = [];
  master_id: number;

  template: Template;
  templates = [];
  template_count = 0;
  templateFilter;
  dateFilter;
  agentFilter;

  selected_share = '';

  results: any[] = [];
  type = '';

  campaigns = [];

  // updated subscriptions
  subgroupsSubscription: Subscription;

  templatesSubscription: Subscription;
  templateShareSubscription: Subscription;

  templateAddForm: FormGroup;
  templateUpdateForm: FormGroup;
  templateDuplicateForm: FormGroup;
  shareToClientForm: FormGroup;
  shareToUserForm: FormGroup;
  shareToSubgroupForm: FormGroup;

  pane_open = false;

  first_template_id = '';

  public edit_index: number;
  public edit_title_id: number;
  public edit_title_name: string;

  TEMPLATE_THUMB_S3_URL = '';

  listing: any;

  templateId = 0;

  @ViewChild('categoryContent') categoryContent: ElementRef;
  @ViewChild('newTemplate') newTemplate: ElementRef;
  @ViewChild('newTemplateModalClose') newTemplateModalClose: ElementRef;
  @ViewChild('previewModal') previewModal: ElementRef;
  @ViewChild('editTitleModalClose') editTitleModalClose: ElementRef;
  @ViewChild('editTitle') editTitle: ElementRef;
  @ViewChild('previewTour') previewTour: ElementRef;
  @ViewChild('duplicateTemplate') duplicateTemplate: ElementRef;
  @ViewChild('duplicateTemplateModalClose') duplicateTemplateModalClose: ElementRef;

  @ViewChild('shareToModalClose') shareToModalClose: ElementRef;
  @ViewChild('shareToUserModalClose') shareToUserModalClose: ElementRef;

  authUser: Auth;
  agentUsers = [];

  mdLink = '';

  categoryList = [];

  term;
  supportLink = '';
  shareListClients = [];
  shareListUsers = [];
  selectedSharedClient = [];
  selectedSharedUser = [];
  selectedSubGroup = [];
  shared_template_id: number;

  subgroups: Client[];

  _tmp_template: any;

  offset = 0;
  is_archive = false;

  current_sort_by = 'created_DESC';
  current_template_filter = '';
  current_agent_filter = '';

  isFetchedAlready = false;

  isCampaignDashboard = false;

  campaign: any;
  isList = false;

  campaignTemplateForm: FormGroup;

  constructor(public frontService: FrontService,
              private clientService: ClientService,
              private masterService: MasterService,
              private templateService: TemplateService,
              private subgroupService: SubgroupService,
              private router: Router,
              private vaultService: VaultService,
              private campaignService: CampaignService,
              private globalService: GlobalService,
              private changeDetector: ChangeDetectorRef,
              private domainService: DomainService,
              private mydesktopService: MyDesktopService
            ) {
                const $this = this;
                let selectedColor = '';
                this.authUser = this.frontService.authService.auth;

                if ( this.authUser.brandid === '6' ) {
                  selectedColor = '-orange';
                }

                if ( this.authUser.client.group.ID === 1 && !this.globalService.appConfig.IS_UK ) {
                  this.categoryList.push({
                    id: 0,
                    slug: 'websites',
                    name: 'Websites',
                    icon: `assets/img/website-icon-02${selectedColor}.svg`,
                    masters: [
                      {
                        title: 'Real Estate Website',
                        icon: 'assets/img/realestate-website-icon.svg',
                        static: true,
                        url: '/websites/agency-website'
                      },
                      {
                        title: 'Agent Only Website',
                        icon: 'assets/img/agent-website-icon.svg',
                        static: true,
                        url: '/websites/agent-only-website'
                      },
                      {
                        title: 'Lead Generating Website',
                        icon: 'assets/img/leadgen-icon.svg',
                        static: true,
                        url: '/websites/lead-generating-website'
                      }
                    ]
                  });
                } else {
                  this.categoryList.push({
                    id: 0,
                    slug: 'soon',
                    name: 'Coming Soon',
                    icon: `assets/img/coming-soon-icon${selectedColor}.svg`,
                    masters: []
                  });
                }

                this.categoryList.push({
                  id: [1, 2, 3, 7],
                  slug: 'enewsletter',
                  name: 'eMarketing',
                  icon: `assets/img/temp1${selectedColor}.svg`,
                  masters: []
                },
                {
                  id: [4, 8],
                  slug: 'brochure',
                  name: 'Brochures / Window Cards / DL’s',
                  icon: `assets/img/brochure${selectedColor}.svg`,
                  masters: []
                },
                {
                  id: 5,
                  slug: 'property-guide',
                  name: 'Property Guide / MyGuide / Stocklist',
                  icon: 'assets/img/temp7.svg',
                  masters: []
                },
                {
                  id: 6,
                  slug: 'social-media',
                  name: 'Social Media',
                  icon: 'assets/img/social-media.svg',
                  masters: []
                },
                {
                  id: 9,
                  slug: 'sign-board',
                  name: 'Signboard',
                  icon: 'assets/img/signboard.svg',
                  masters: []
                });

                window['onClickSend'] = function(link, val) {
                  $this.onClickSend(link, val);
                };
              }

  @ViewChild('propertySearchModalClose') mdPropSearchModalClose: ElementRef;
  @Input() page: string;
  ngOnInit() {
    this.supportLink = this.frontService.supportLink;
    this.shareListUsers = this.authUser.client.users;

    if ( this.frontService.authService.getApp() === 'Designly' ) {
      this.isList = true;
    }

    if ( this.page === 'campaign' ) {
      this.isCampaignDashboard = true;
      this.isList = false;
    } else {
      localStorage.removeItem('backUrl');
    }

    if ( this.authUser.is_master ) {
      this.selected_share = 'offices';
    } else if ( this.authUser.is_subgroup ) {
      this.selected_share = 'subgroup';
    } else {
      this.selected_share = 'agent';
    }

    if ( this.authUser.is_subgroup ) {
      this.clientService.httpGetClientsOfSubGroupID(
        {
          subgroup_id: this.authUser.client.subgroup_id
        },
        'list'
      );
      // this.subgroupService.httpGetSubgroups({
      //   'ID': this.authUser.client.subgroup_id,
      //   is_account_active: '1'
      // });
    }

    if (this.authUser.can_share && this.authUser.is_master) {
      this.clientService.httpGetClientsOfGroupID(
        {
          group_id: this.authUser.client.group_id,
          is_account_active: '1',
          provider: this.authUser.provider
        },
        'list'
      );
    }

    this.domainService.onGetDomainListing
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.status === 'success' ) {
          this.loading = false;
          this.listing = response.data;

          let campaignTemplateQuery = {};

          if ( this.campaignService.isCustom ) {
            campaignTemplateQuery = {
              campaign_id: this.campaignService.campaignId,
              category: `custom_${this.campaignService.campaignId}`
            };
            this.campaignService.backUrl = `/campaigns/${this.campaignService.campaignId}/${this.listing.id}/view?status=${this.campaignService.vaultStatus}&category=${this.campaignService.campaignCategory}`
            this.listing['campaign_id'] = this.campaignService.campaignId;
          } else {
            campaignTemplateQuery = {
              campaign_id: this.listing.campaign_id,
              category: this.listing.campaign_category
            };
            this.campaignService.backUrl = `/campaigns/listing/${this.listing.id}/view?status=${this.campaignService.vaultStatus}&category=${this.campaignService.campaignCategory}`;
          }

          this.templateService.httpGetTemplates(
            campaignTemplateQuery,
            'dashboard',
            this.current_sort_by
          );
        }
      }
    );

    this.mydesktopService.myDesktopGetNewListing
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.status === 'success' ) {
          this.loading = false;
          this.listing = response.data;

          let campaignTemplateQuery = {};

          if ( this.campaignService.isCustom ) {
            campaignTemplateQuery = {
              campaign_id: this.campaignService.campaignId,
              category: `custom_${this.campaignService.campaignId}`
            };
            this.campaignService.backUrl = `/campaigns/${this.campaignService.campaignId}/${this.listing.id}/view?status=${this.campaignService.vaultStatus}&category=${this.campaignService.campaignCategory}`
            this.listing['campaign_id'] = this.campaignService.campaignId;
          } else {
            campaignTemplateQuery = {
              campaign_id: this.listing.campaign_id,
              category: this.listing.campaign_category
            };
            this.campaignService.backUrl = `/campaigns/listing/${this.listing.id}/view?status=${this.campaignService.vaultStatus}&category=${this.campaignService.campaignCategory}`;
          }

          this.templateService.httpGetTemplates(
            campaignTemplateQuery,
            'dashboard',
            this.current_sort_by
          );
        }
      }
    );

    this.vaultService.onVaultGetListing
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        console.log(response);
        if ( typeof response !== 'undefined' && response.status === 'success' ) {
          this.loading = false;
          this.listing = response.data;

          let campaignTemplateQuery = {};

          if ( this.campaignService.isCustom ) {
            campaignTemplateQuery = {
              campaign_id: this.campaignService.campaignId,
              category: `custom_${this.campaignService.campaignId}`
            };
            this.campaignService.backUrl = `/campaigns/${this.campaignService.campaignId}/${this.listing.id}/view?status=${this.campaignService.vaultStatus}&category=${this.campaignService.campaignCategory}`
            this.listing['campaign_id'] = this.campaignService.campaignId;
          } else {
            campaignTemplateQuery = {
              campaign_id: this.listing.campaign_id,
              category: this.listing.campaign_category
            };
            this.campaignService.backUrl = `/campaigns/listing/${this.listing.id}/view?status=${this.campaignService.vaultStatus}&category=${this.campaignService.campaignCategory}`;
          }

          this.templateService.httpGetTemplates(
            campaignTemplateQuery,
            'dashboard',
            this.current_sort_by
          );
        }
        if ( typeof response !== 'undefined' && response.status === 'error' ) {
          this.loading = false;
          swal(
            'Vault API Error',
            response.message,
            'error'
          );
        }
      }
    );

    this.subgroupsSubscription = this.clientService.ClientsOfSubGroupID
    .takeUntil(this.destroy$)
    .subscribe(
      (subgroups: Client[]) => {
        if ( typeof subgroups !== 'undefined' && subgroups.length > 0 ) {
          this.subgroups = subgroups;
        }
      }
    );

    this.clientService.ClientsOfGroupID
    .takeUntil(this.destroy$)
    .subscribe(
      (clients: Client[]) => {
        this.shareListClients = clients;
      }
    );

    const tempAgentUsers = this.shareListUsers;
    this.agentUsers = tempAgentUsers.sort(function(a, b) {
      const x = a.firstname.toLowerCase();
      const y = b.firstname.toLowerCase();
      return x < y ? -1 : x > y ? 1 : 0;
    });

    this.loading = true;
    this.frontService.loadMenu(this.menus);

    for ( const category of this.categoryList) {
      if (category.slug === 'soon') {
        this.masterService.httpGetMasters(
          {
            group_id: this.authUser.client.group_id,
            is_active: '2',
            client_id: [0, this.authUser.client.ID],
            subgroup_id: this.authUser.client.subgroup_id,
            provider: ['all', this.authUser.provider]
          },
          '',
          '',
          '',
          category.slug
        );
      } else {
        this.masterService.httpGetMasters(
          {
            category_id: category.id,
            group_id: this.authUser.client.group_id,
            is_active: '1',
            client_id: [0, this.authUser.client.ID],
            subgroup_id: this.authUser.client.subgroup_id,
            provider: ['all', this.authUser.provider]
          },
          '',
          '',
          '',
          category.slug
        );
      }
    }

    this.masterService.mastersChanged
    .takeUntil(this.destroy$)
    .subscribe(
      (masters: Master[]) => {
        if (typeof masters !== 'undefined' && masters.length > 0) {
          this.masters = masters;
        }
      }
    );

    this.masterService.mastersCategoryComingSoon
    .takeUntil(this.destroy$)
    .subscribe(
      (masters: Master[]) => {
        if (typeof masters !== 'undefined' && masters.length > 0) {
          const masterComingSoonIndex = this.categoryList.findIndex(g => g.slug === 'soon');

          this.categoryList[ masterComingSoonIndex ].masters = masters;
        }
      }
    );

    this.masterService.mastersCategoryEMarketing
    .takeUntil(this.destroy$)
    .subscribe(
      (masters: Master[]) => {
        if (typeof masters !== 'undefined' && masters.length > 0) {
          const masterEMarketingIndex = this.categoryList.findIndex(g => g.slug === 'enewsletter');

          this.categoryList[ masterEMarketingIndex ].masters = masters;
        }
      }
    );

    this.masterService.mastersCategoryBrochure
    .takeUntil(this.destroy$)
    .subscribe(
      (masters: Master[]) => {
        if (typeof masters !== 'undefined' && masters.length > 0) {
          const masterBrochureIndex = this.categoryList.findIndex(g => g.slug === 'brochure');

          this.categoryList[ masterBrochureIndex ].masters = masters;
        }
      }
    );

    this.masterService.mastersCategoryPropertyGuide
    .takeUntil(this.destroy$)
    .subscribe(
      (masters: Master[]) => {
        if (typeof masters !== 'undefined' && masters.length > 0) {
          const masterPropertyGuideIndex = this.categoryList.findIndex(g => g.slug === 'property-guide');

          this.categoryList[ masterPropertyGuideIndex ].masters = masters;
        }
      }
    );

    this.masterService.mastersCategorySocialMedia
    .takeUntil(this.destroy$)
    .subscribe(
      (masters: Master[]) => {
        if (typeof masters !== 'undefined' && masters.length > 0) {
          const masterSocialMediaIndex = this.categoryList.findIndex(g => g.slug === 'social-media');

          this.categoryList[ masterSocialMediaIndex ].masters = masters;
        }
      }
    );

    this.masterService.mastersCategorySignboard
    .takeUntil(this.destroy$)
    .subscribe(
      (masters: Master[]) => {
        if (typeof masters !== 'undefined' && masters.length > 0) {
          const masterSocialMediaIndex = this.categoryList.findIndex(g => g.slug === 'sign-board');

          this.categoryList[ masterSocialMediaIndex ].masters = masters;
          $('#intro-sign-board').css('display', 'table');
          $('.create-template .category-tab ul li').css('width', '14%');
        }
      }
    );

    this.templateService.templateShare
    .takeUntil(this.destroy$)
    .subscribe(
      (template: any) => {
        if ( typeof template !== 'undefined' && template.status === 'success' ) {
          this.loading = false;
          swal({
            title: 'Success',
            text: 'Template Sharing preferences updated. Page will automatically reload in few seconds',
            type: 'success',
            showConfirmButton: false,
            confirmButtonText: 'OK'
          });
          setTimeout(() => {
            window.location.href = '/templates';
          }, 3000);
        }
      }
    );

    let templateQuery = {
      user_agent_id: `${this.authUser.user.ID},${this.authUser.user.agent_id}`,
      client_id: this.authUser.client.ID,
      group_id: this.authUser.client.group_id,
      is_active: '1',
      offset: this.offset
    };

    if ( this.authUser.is_admin || this.authUser.client.group_id === 12 ) {
      delete templateQuery.user_agent_id;
    }

    if ( !this.isCampaignDashboard ) {
      this.templateService.httpGetTemplates(
        templateQuery,
        'dashboard',
        this.current_sort_by
      );
    }

    this.templateService.templateDeletion
    .takeUntil(this.destroy$)
    .subscribe(
      (template: Template) => {
        if ( typeof template.ID !== 'undefined' ) {
          this.loading = false;

          $(`.template-${template.ID}`).css('display', 'block');
          $(`.actions-${template.ID}`).html('<strong>Deleted</strong>');
        }
      }
    );

    this.templateService.templateDuplicate
    .takeUntil(this.destroy$)
    .subscribe(
      (template: Template) => {
        if ( typeof template.ID !== 'undefined' ) {

          templateQuery = {
            user_agent_id: `${this.authUser.user.ID},${this.authUser.user.agent_id}`,
            client_id: this.authUser.client.ID,
            group_id: this.authUser.client.group_id,
            is_active: '1',
            offset: this.offset
          };

          if ( this.authUser.is_admin ) {
            delete templateQuery.user_agent_id;
          }

          this.templateService.httpGetTemplates(
            templateQuery,
            '',
            this.current_sort_by
          );

          this.changeDetector.detectChanges();
        }
      }
    );

    this.templatesSubscription = this.templateService.templateGetAll
    .takeUntil(this.destroy$)
    .subscribe(
      (templates: any) => {
        if ( typeof templates !== 'undefined' && templates.status === 'success' ) {
          this.loading = false;
          if ( this.offset === 0 ) {
            this.templates = templates.data;
          } else {
            this.templates = this.templates.concat(templates.data);
          }

          this.template_count = templates.total_count;
          this.templateFilter = 'all';
          this.dateFilter = 'recent';
          this.agentFilter = 'all';

          if ( this.frontService.authService.auth.first === '1' ) {
            setTimeout(() => {
              this.startTour();
              this.frontService.authService.updateAuthCookieField('first', '0');

              // set settings, builder tour to 1
              localStorage.setItem('first_builder', '1');
              localStorage.setItem('first_settings', '1');
              this.loading = false;
            }, 500);

          }

          this.changeDetector.detectChanges();
        }
      }
    );

    this.templateService.templateOperation
    .takeUntil(this.destroy$)
    .subscribe(
      (template: Template) => {
        if ( typeof template.ID !== 'undefined' ) {
          this.loading = false;

          swal(
            'Updated!',
            'Template has been updated.',
            'success'
          );

          if ( this.is_archive ) {
            this.is_archive = false;
            $('.template-' + template.ID).css('display', 'block');
            $('.disabled-text-' + template.ID).text('Archived');
          } else {
            this.offset = 0;

            templateQuery = {
              user_agent_id: `${this.authUser.user.ID},${this.authUser.user.agent_id}`,
              client_id: this.authUser.client.ID,
              group_id: this.authUser.client.group_id,
              is_active: '1',
              offset: 0
            };

            if ( this.authUser.is_admin ) {
              delete templateQuery.user_agent_id;
            }

            this.templateService.httpGetTemplates(
              templateQuery,
              '',
              this.current_sort_by
            );
          }

          this.changeDetector.detectChanges();
        }
      }
    );

    this.templateService.templateCreation
    .takeUntil(this.destroy$)
    .subscribe(
      (template: Template) => {
        if ( typeof template.ID !== 'undefined' ) {
          this.loading = false;
          this.router.navigate(['/templates/' + template.ID + '/build']);

          if (this.page === 'campaign') {
            if ( this.campaignService.isCustom ) {
              this.campaignService.backUrl = `/campaigns/${this.campaignService.campaignId}/${this.listing.id}/view?status=${this.campaignService.vaultStatus}&category=${this.campaignService.campaignCategory}`
            } else {
              this.campaignService.backUrl = `/campaigns/listing/${this.listing.id}/view?status=${this.campaignService.vaultStatus}&category=${this.campaignService.campaignCategory}`;
            }
          }

          this.changeDetector.detectChanges();
        }
      }
    );

    this.vaultService.onVaultSendTemplate
    .takeUntil(this.destroy$)
    .subscribe(
      (vault: any) => {
        if ( typeof vault !== 'undefined' && vault.status === 'success' ) {
          this.loading = false;
          swal({
            title: 'Template has been added/saved to your VaultRE account',
            type: 'success',
            html:
            // tslint:disable-next-line:max-line-length
            '<a target="_blank" href="https://login.vaultre.com.au/cgi-bin/clientvault/emarketing/bulk.cgi?messagetype=designly&designlytemplateid=' + vault.data.id + '" class="btn btn-primary">View</a>',
            showCancelButton: false,
            showConfirmButton: false,
            focusConfirm: false
          });

          this.changeDetector.detectChanges();
        }
      }
    );

    this.globalService.onSelectListing
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( response ) {
          this.loading = true;
          this.mdPropSearchModalClose.nativeElement.click();
          this.changeDetector.detectChanges();
        }
      }
    );

    this.campaignService.campaignBuildTemplates
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.status === 'success' ) {
          window.location.reload();

          this.loading = false;
          this.changeDetector.detectChanges();
        }
      }
    );

    this.campaignService.campaignExport
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.status === 'success' ) {
          this.loading = false;

          swal(
            'Success',
            'You can now download the zip file',
            'success'
          );

          const link = document.createElement('a');
          link.download = `${this.listing.id}.zip`;
          link.href = response.file;
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          link.remove();

          this.changeDetector.detectChanges();
        }
        if ( typeof response !== 'undefined' && response.status === 'okempty' ) {
          this.loading = false;
          swal(
            'Unable to export campaign',
            'Make sure you have generated this campaign',
            'warning'
          );
        }
      }
    );

    this.campaignService.campaignOnGenerateFinish
    .takeUntil(this.destroy$)
    .subscribe(
      (response: boolean) => {
        if (response) {
          window.location.reload();

          this.loading = false;
          this.changeDetector.detectChanges();
        }
        if (!response) {
          swal(
            'Unable to generate campaign',
            'Make sure you have saved templates to this campaign',
            'warning'
          );
          this.loading = false;
        }
      }
    );

    this.campaignService.campaignRemoveListingFromCampaign
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if (typeof response !== 'undefined' && response.status === 'success') {
          $(`.template-${this.ID}`).css('display', 'block');
          $(`.actions-${this.ID}`).html('<strong>Removed</strong>');

          this.loading = false;
        }
      }
    );

    this.campaignService.campaignGetAll
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.status === 'success' ) {
          this.loading = false;
          this.campaigns = response.data;
          $('#addTemplate').modal('show');
        }
      }
    );

    this.campaignService.campaignPostTemplate
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.status === 'success' ) {
          this.loading = false;
          swal(
            'Saved to Selected Categories',
            '',
            'success'
          );
          this.campaignTemplateForm.reset();
          $('#addTemplate').modal('hide');
        }
      }
    );

    this.templateService.templateRefresh
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && response.status === 'success' ) {
          this.loading = false;
          window.location.reload();
        }
      }
    );

    this.TEMPLATE_THUMB_S3_URL = this.frontService.appConfig.S3_URL + 'templates/thumbnails/';

    this.initForm();
  }

  private initForm() {
    this.templateAddForm = new FormGroup({
      'title': new FormControl('', Validators.required),
      'user_agent_id': new FormControl(this.authUser.agentid, Validators.required),
    });

    this.templateDuplicateForm = new FormGroup({
      'ID': new FormControl('', Validators.required),
      'title': new FormControl('', Validators.required),
      'user_agent_id': new FormControl(this.authUser.agentid, Validators.required),
    });

    this.templateUpdateForm = new FormGroup({
      'ID': new FormControl('', Validators.required),
      'title': new FormControl('', Validators.required)
    });

    this.shareToClientForm = new FormGroup({
      'ID': new FormControl('', Validators.required),
      'client_id': new FormControl('', Validators.required)
    });

    this.shareToUserForm = new FormGroup({
      'ID': new FormControl('', Validators.required),
      'user_id': new FormControl('', Validators.required)
    });

    this.shareToSubgroupForm = new FormGroup({
      'ID': new FormControl('', Validators.required),
      'subgroup_id': new FormControl('', Validators.required)
    });

    this.campaignTemplateForm = new FormGroup({
      'category': new FormControl('', Validators.required)
    });
  }

  showAll() {
    const panes = this.categoryContent.nativeElement.querySelectorAll('.tab-pane');

    for ( const pane of panes ) {
      pane.className = 'tab-pane active';
    }

    this.pane_open = true;
  }

  hideAll() {
    const panes = this.categoryContent.nativeElement.querySelectorAll('.tab-pane');

    for ( const pane of panes ) {
      pane.className = 'tab-pane';
    }

    this.pane_open = false;
  }

  hideNotThis(current) {
     jQuery('.tab-pane').removeClass('active');
     jQuery('#' + current).addClass('active');
  }

  onModal(item) {
    this.master = item;
    this.newTemplate.nativeElement.querySelector('#newTemplateLabel').innerHTML = 'Add ' + item.title;
  }

  onSubmit() {
    if (this.templateAddForm.valid) {
      this.loading = true;

      const templateAddValues = this.templateAddForm.value;
      // templateAddValues['user_agent_id'] = this.authUser.agent.id;
      if (!this.authUser.is_admin) {
        templateAddValues['user_agent_id'] = this.authUser.agentid;
      }
      templateAddValues['user_id'] = this.authUser.user.ID;
      templateAddValues['client_id'] = this.authUser.client.ID;
      templateAddValues['master_id'] = this.master.ID;
      templateAddValues['category_id'] = this.master.category_id;
      templateAddValues['group_id'] = this.master.group_id;
      templateAddValues['media_attribute_id'] = this.master.media_attribute_id;
      templateAddValues['department_id'] = this.master.department_id;
      templateAddValues['is_active'] = 1;

      if ( this.page === 'campaign' && typeof this.listing.campaign_id !== 'undefined' ) {
        templateAddValues['campaign_id'] = this.listing.campaign_id;
      }

      this.templateService.httpPostTemplate(templateAddValues);

      setTimeout(
        () => {
          this.templateAddForm.reset();
          this.newTemplateModalClose.nativeElement.click();
          // this.router.navigate(['/templates/'+lastInserted.ID+'/build']);
        }, 500
      );

    }
  }

  onSubmitDuplicate() {
    if (this.templateDuplicateForm.valid) {
      this.loading = true;

      const templateAddValues = this.templateDuplicateForm.value;

      this.templateService.httpDuplicateTemplate(templateAddValues.ID, templateAddValues);

      setTimeout(
        () => {
          this.templateDuplicateForm.reset();
          this.duplicateTemplateModalClose.nativeElement.click();
        }, 500
      );

    }
  }
  onSubmitUpdate() {
    if (this.templateUpdateForm.valid) {
      this.loading = true;

      const templateAddValues = this.templateUpdateForm.value;

      this.templateService.httpPutTemplate(templateAddValues.ID, templateAddValues);

      setTimeout(
        () => {
          this.templateUpdateForm.reset();
          this.editTitleModalClose.nativeElement.click();
        }, 500
      );

    }
  }

  onDuplicate(item) {
    this.templateDuplicateForm.patchValue({
      'ID':  item.ID,
      'title': item.title
    });

    $('#duplicateTemplate').modal('show');
  }

  onShare(template: any) {
    this._tmp_template = template;

    if ( this.selected_share === 'offices' ) {
      this.onShareToClient();
    }

    if ( this.selected_share === 'subgroup' ) {
      this.onShareToSubGroup();
    }

    if ( this.selected_share === 'agent' ) {
      this.onShareToUser();
    }
  }

  onShareToClient() {
    const template = this._tmp_template;

    this.selectedSharedClient = [];
    this.shared_template_id = template.ID;

    jQuery('#shareTo').find('input[type="checkbox"]').prop('checked', false);

    for ( const share_client of template.share_clients) {
      this.selectedSharedClient.push(share_client.client_id);
      jQuery('#shareTo').find('input[value="' + share_client.client_id + '"]').prop('checked', true);
    }
  }

  onShareToSubGroup() {
    const template = this._tmp_template;

    this.selectedSubGroup = [];
    this.shared_template_id = template.ID;

    jQuery('#shareTo').find('input[type="checkbox"]').prop('checked', false);

    for ( const share_subgroup of template.share_subgroups) {
      this.selectedSubGroup.push(share_subgroup.client_id);
      jQuery('#shareTo').find('input[value="' + share_subgroup.client_id + '"]').prop('checked', true);
    }
  }

  onClear() {
    jQuery('#shareTo').find('input[type="checkbox"]').prop('checked', false);

    this.selectedSharedClient = [];
  }

  onSelectAll() {
    jQuery('#shareTo').find('input[type="checkbox"]').prop('checked', true);

    const elValues = jQuery('#shareToClient input:checkbox:checked').map(function() {
        return this.getAttribute('value');
    }).get();

    this.selectedSharedClient = elValues;
  }

  hasShareable(template): boolean {
    if ( template.share_clients !== 'undefined' ) {
      // tslint:disable-next-line:curly
      if ( template.share_clients.length > 0 )
        return true;
    }

    if ( template.share_subgroups !== 'undefined' ) {
      // tslint:disable-next-line:curly
      if ( template.share_subgroups.length > 0 )
        return true;
    }

    if ( template.share_users !== 'undefined' ) {
      // tslint:disable-next-line:curly
      if ( template.share_users.length > 0 )
        return true;
    }

    return false;
  }

  onCheckSharedClient(el: any) {
    const elCheckbox = el.target;
    const elIsChecked = elCheckbox.checked;
    const elValue = +elCheckbox.value;
    const elExist = this.selectedSharedClient.indexOf(elValue);

    if ( elIsChecked  ) {
      if ( elExist === -1 ) {
        this.selectedSharedClient.push(elValue);
      }
    } else {
      if ( elExist !== -1 ) {
        this.selectedSharedClient.splice(elExist, 1);
      }
    }
  }

  onSubmitShareToClient() {
    this.loading = true;
    const sharedClientValues: Object = {};

    sharedClientValues['share_type'] = 'client';
    sharedClientValues['share_ids'] = this.selectedSharedClient;

    this.templateService.httpPutTemplate(this.shared_template_id, <any>sharedClientValues);

    setTimeout(
      () => {
        this.templateUpdateForm.reset();
        this.shareToModalClose.nativeElement.click();
      }, 500
    );
  }

  onShareToUser() {
    const template = this._tmp_template;

    this.selectedSharedUser = [];
    this.shared_template_id = template.ID;

    jQuery('#shareTo').find('input[type="checkbox"]').prop('checked', false);

    for ( const share_user of template.share_users) {
      this.selectedSharedUser.push(share_user.user_id);
      jQuery('#shareTo').find('input[value="' + share_user.user_id + '"]').prop('checked', true);
    }
  }

  onClearShareToUser() {
    jQuery('#shareToUser').find('input[type="checkbox"]').prop('checked', false);
  }

  onSelectAllShareToUser() {
    jQuery('#shareToUser').find('input[type="checkbox"]').prop('checked', true);
  }

  onCheckSharedUser(el: any) {
    const elCheckbox = el.target;
    const elIsChecked = elCheckbox.checked;
    const elValue = +elCheckbox.value;
    const elExist = this.selectedSharedUser.indexOf(elValue);

    if ( elIsChecked  ) {
      if ( elExist === -1 ) {
        this.selectedSharedUser.push(elValue);
      }
    } else {
      if ( elExist !== -1 ) {
        this.selectedSharedUser.splice(elExist, 1);
      }
    }
  }

  onSubmitShareToUser() {
    this.loading = true;
    const sharedUserValues: Object = {};

    sharedUserValues['share_type'] = 'user';
    sharedUserValues['share_ids'] = this.selectedSharedUser;

    this.templateService.httpPutTemplate(this.shared_template_id, <any>sharedUserValues);

    setTimeout(
      () => {
        this.templateUpdateForm.reset();
        this.shareToUserModalClose.nativeElement.click();
      }, 500
    );
  }

  onShareOffice(item: Template) {
    this.loading = true;
    const templateValues: Object = {};

    const shareValue = 2;

    templateValues['is_shared'] = (item.is_shared) ? 0 : shareValue;
    // this.templateService.httpPutTemplate(item.ID, <Template>templateValues);
  }

  onArchive(id: number) {
    this.loading = true;

    const templateValues: Object = {};
    templateValues['is_active'] = 0;
    this.templateService.httpPutTemplate(id, <Template>templateValues);
    this.is_archive = true;
  }

  onDelete(id: number) {
    const $this = this;
    swal({
      title: 'Are you sure you want to delete this template?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Delete'
    }).then(function () {
      $this.loading = true;
      swal(
        'Deleted!',
        'Your file has been deleted.',
        'success'
      );
      $this.templateService.httpDeleteTemplate(id);
    });

  }

  onPreview(template: any) {
    let img_src = '';
    if ( template.thumbnail === '' ) {
      img_src = template.ID + '.jpg';
    } else {
      img_src = template.thumbnail;
    }

    this.previewModal.nativeElement.querySelector('.modal-body img').src
      = this.frontService.appConfig.S3_URL + 'templates/thumbnails/' + img_src;

    $('#previewTemplate').modal('show');
  }

  onEditTitle($id: number, $name: string) {
    this.edit_title_id = $id;
    this.edit_title_name = $name;
    $('#editTitle').modal('show');
  }

  ngOnDestroy() {
    this.frontService.authService.cancelRequest();

    this.destroy$.next(true);
    this.destroy$.unsubscribe();

    this.offset = 0;
  }

  onTour() {
    /*
    * Proposed - not  yet working
    */
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngAfterContentInit() {
    jQuery(document).on('click', '.template-view', function(e){
      e.preventDefault();
      const view = jQuery(this).attr('data-view');

      jQuery('.template-view').removeClass('active');
      jQuery(this).addClass('active');

      if (view === 'list') {
            jQuery('#arrangement-grid').removeClass('active');
            jQuery('.media-list').removeClass('is-grid').addClass('is-list');
      } else {
            jQuery('#arrangement-list').removeClass('active');
            jQuery('.media-list').removeClass('is-list').addClass('is-grid');
      }
    });
  }

  getAgentData(id, type) {
    const agentID = this.shareListUsers.findIndex(a => +a.id === id);
    if ( typeof this.shareListUsers[ agentID ] !== 'undefined') {
      return this.shareListUsers[ agentID ][ type ];
    }

    return ' ';
  }

  startTour() {
    const $this = this;
    const intro = introJs();

    intro.setOption('disableInteraction', true);
    intro.setOption('exitOnOverlayClick', false);
    intro.setOption('hidePrev', true);
    intro.setOption('hideNext', true);
    intro.setOption('overlayOpacity', '0.5');

    if ( localStorage.getItem('md3_first_template_id') !== null ) {
      intro.setOption('doneLabel', 'Proceed to Builder');
      this.first_template_id = localStorage.getItem('md3_first_template_id');

      // remove
      localStorage.removeItem('md3_first_template_id');
    }

    intro.addSteps([
      {
        element: document.querySelector('.btn-tour'),
        intro: 'Take a Tour - Dashboard. Provides a step-by-step guide to the home page including Templates.'
      },
      {
        element: document.querySelector('.category-tab'),
        intro: 'Categories - Click the category to view the template types available, and make your selection from there.'
      },
      {
        element: document.querySelector('#intro-soon'),
        intro: 'Coming Soon - Here you can see what is currently in the works and will eventually be implemented as a Template.'
      },
      {
        element: document.querySelector('#intro-enewsletter'),
        intro: 'eMarketing - Here you can create a Market Report, Include Email Signatures, design eCards and create an eNewsletter.'
      },
      {
        element: document.querySelector('#intro-brochure'),
        // tslint:disable-next-line:max-line-length
        intro: 'Printable Templates - Here you can create a Brochure or a Window Card/DL, you can choose a layout for the brochure in 2 different page sizes and 2 different orientations.'
      },
      {
        element: document.querySelector('#intro-property-guide'),
        intro: 'Property Guide - Here you can create either a Property Guide or a Stocklist.'
      },
      {
        element: document.querySelector('#intro-social-media'),
        // tslint:disable-next-line:max-line-length
        intro: 'Social Media - Here you can create an Image post which can be uploaded to either Instagram, Twitter or Facebook at your own leisure.'
      },
      {
        element: document.querySelector('#view-toggle'),
        // tslint:disable-next-line:max-line-length
        intro: 'View All - Click here to expand all categories and display all available Templates.'
      },
      {
        element: document.querySelector('.intro-template'),
        // tslint:disable-next-line:max-line-length
        intro: 'Your Templates - Displays all of the Templates that you have created or have access to, and displays the number of Templates.'
      },
      {
        element: document.querySelector('.intro-view'),
        // tslint:disable-next-line:max-line-length
        intro: 'View - Displays a preview of the template layout that allows you to view the Template without having to edit it.'
      },
      {
        element: document.querySelector('.intro-edit'),
        intro: 'Edit - Opens the Template in the builder for you to make changes'
      },
      {
        element: document.querySelector('.intro-send'),
        // tslint:disable-next-line:max-line-length
        intro: 'Send - Links to MyDesktop for you to send to your database (Note: this can only be done with any Template made within the eMarketing category).'
      },
      {
        element: document.querySelector('.intro-share'),
        intro: 'Share - Allows you to share a Template with all agents in your office and can be undone at any time.'
      },
      {
        element: document.querySelector('.intro-duplicate'),
        intro: 'Duplicate - Creates a copy of the Template and all elements within the Template.'
      },
      {
        element: document.querySelector('.intro-archive'),
        // tslint:disable-next-line:max-line-length
        intro: 'Archive - Removes the Template from the list and places it into the Archive Templates tab on the sidebar and this can be undone at any time.'
      },
      {
        element: document.querySelector('.intro-delete'),
        intro: 'Delete - Deletes the Template and CANNOT BE UNDONE.'
      },
      {
        element: document.querySelector('.intro-info'),
        intro: 'Template Info - This displays the Template name, the date it was created and the agent who created it.'
      },
      {
        element: document.querySelector('.intro-tag'),
        intro: 'Template Tag - This shows the category that the Template is from, helpful when wanting to search for specific Templates.'
      },
      {
        element: document.querySelector('.input-search'),
        intro: 'Search - Here you can search for a particular Template by typing here in the search bar.'
      },
      {
        element: document.querySelector('.intro-date'),
        intro: 'Sort - Here you can sort your Templates by either date or title.'
      },
      {
        element: document.querySelector('.intro-template-filter'),
        intro: 'Template Filter - Here you can filter your Templates by the Template Tag.'
      },
      {
        element: document.querySelector('.intro-agent'),
        intro: 'Agent Filter - Here you can filter your Templates by which agents created them.'
      },
      {
        element: document.querySelector('.intro-view-option'),
        intro: 'View Options - Here you can choose to display the Templates in either Grid or List view.'
      },
      {
        element: document.querySelector('.intro-side-template'),
        intro: 'Templates - This is the homepage where you can access your Templates.',
        position: 'right'
      },
      {
        element: document.querySelector('.intro-side-shared'),
        // tslint:disable-next-line:max-line-length
        intro: 'Shared Templates - Here you can view Templates that you have shared, Templates that your group has access to and Templates that your office has access to.',
        position: 'right'
      },
      {
        element: document.querySelector('.intro-side-archive'),
        // tslint:disable-next-line:max-line-length
        intro: 'Archive Templates - Here you can access templates that you have archived and choose to either view or activate (Unarchive) any Template.',
        position: 'right'
      },
      {
        element: document.querySelector('.intro-side-analytics'),
        // tslint:disable-next-line:max-line-length
        intro: 'Analytics - Here you can access information such as recent activity, top used Templates, Template Reports and Login Reports.',
        position: 'right'
      },
      {
        element: document.querySelector('.intro-side-library'),
        // tslint:disable-next-line:max-line-length
        intro: 'My Image Library - Here you can view either your Image Library, which is your personal images you can use, or Shared Library, which is images shared with you by other agents in your office/group.',
        position: 'right'
      },
      {
        element: document.querySelector('.intro-side-setting'),
        // tslint:disable-next-line:max-line-length
        intro: 'Settings - Here you can view and change settings regarding Templates and other various resources. You can also Take a Tour in the Settings tab to learn more about Settings.',
        position: 'right'
      },
      {
        element: document.querySelector('.intro-side-support'),
        // tslint:disable-next-line:max-line-length
        intro: 'Support Portal - Here you can view Training videos on how to operate MyDesign, Read FAQs that might be able to assist you if you are having difficulties or Submit a support ticket.”   End tour for Dashboard.',
        position: 'right'
      }
    ]);

    intro.start()
    .onchange( function(element) {
      const el = $(element);
      const step = this._currentStep;

      const template_steps = [ 9, 10, 11, 12, 13, 14 ];
      const bg_89a2ae_steps = [ 1, 2, 3, 4, 5, 6, 7 ];
      const custom_position_steps = [ 18, 19, 20, 21, 22 ];
      const sidebar_steps = [ 23, 24, 25, 26, 27, 28, 29 ];

      if ( template_steps.includes(step) ) {
        $('.overlay-panel').css('opacity', '1');
        setTimeout(() => {
          $('.introjs-helperLayer').css('background-color', '#89a2ae');
        });
      } else {
        $('.overlay-panel').css('opacity', '0');
      }

      if ( bg_89a2ae_steps.includes(step) ) {
        setTimeout(() => {
          $('.introjs-helperLayer').css('background-color', '#89a2ae');
        });
      }

      if ( custom_position_steps.includes(step) ) {
        setTimeout(() => {
          $('.introjs-helperLayer').css('height', '75px');
        });
        setTimeout(() => {
          $('.introjs-tooltip').css('top', '90px');
        }, 500);
      }

      if (  sidebar_steps.includes(step) ) {
        $('#sidebar-wrapper').attr('style', 'z-index: 9999999 !important');
        setTimeout(() => {
          $('.introjs-helperLayer').css({
            'border': '1px solid black',
            'z-index': '99999999',
            'background-color': 'transparent'
          });
        });
        setTimeout(() => {
          $('.introjs-tooltip').attr('style', 'background: #fff !important; border: 1px solid black !important; color: #000');
        }, 300);
      }
    })
    .oncomplete( function() {
      if ( $this.first_template_id !== '' ) {
        $this.router.navigateByUrl('/templates/' + $this.first_template_id + '/build');
      }
    });

  }

  convertDate(date) {
    return moment(date).format('DD/MM/YY');
  }

  sendTemplate(id) {
    let link = 'secure';

    if (this.authUser.brandid === '12' || this.authUser.brandid === '19') {
      link = 'raywhite';
    }
    if (this.authUser.brandid === '13') {
      link = 'rhcompass';
    }
    if ( this.authUser.brandid === '15' ) {
      link = 'rhcorporate';
    }

    if (id === 2) {
      swal({
        title: 'Send',
        type: 'info',
        html:
          // tslint:disable-next-line:max-line-length
          '<a onclick="onClickSend(\'' + link + '\', ' + '\'mydesktop.com.au/cgi-bin/clients/agents/propsearch2.cgi\'' + ')" class="btn btn-primary">Send</a>',
        showCancelButton: false,
        showConfirmButton: false,
        focusConfirm: false
      });
    } else if (id === 3) {
      swal({
        title: 'Send',
        type: 'info',
        html:
          // tslint:disable-next-line:max-line-length
          '<a onclick="onClickSend(\'' + link + '\', ' + '\'mydesktop.com.au/cgi-bin/clients/agents/version6/quickenquiry/managev2.cgi\'' + ')" class="btn btn-primary">Send</a>',
        showCancelButton: false,
        showConfirmButton: false,
        focusConfirm: false
      });
    } else {

      swal({
        title: 'Who do you want to send to?',
        type: 'info',
        html:
          // tslint:disable-next-line:max-line-length
          '<a onclick="onClickSend(\'' + link + '\', ' + '\'mydesktop.com.au/cgi-bin/clients/agents/version6/addressbook/addressbook.cgi\'' + ')" class="btn btn-primary">A single contact</a> &nbsp; <a onclick="onClickSend(\'' + link + '\', ' + '\'mydesktop.com.au/cgi-bin/clients/agents/version6/marketreport4/manage.cgi\'' + ')" class="btn btn-info">Multiple Contacts</a>',
        showCancelButton: false,
        showConfirmButton: false,
        focusConfirm: false
      });
    }
  }

  sendTemplateVault(template) {
    this.vaultService.httpSendTemplate({
      title: `MD3: ${template.title}`,
      subject: template.title,
      content: '',
      propertyTemplate: false,
      template_id: template.ID
    });
    this.loading = true;
  }

  onFeedback() {
    swal({
      title: 'We would love to hear from you about the new MyDesign',
      imageUrl: 'http://mydesign3.wbclients.com/mydesign/assets/images/message-square.svg',
      imageWidth: 300,
      imageHeight: 100,
      showConfirmButton: false,
      html: '<p>Please choose to provide either Feedback or log a Support Ticket</p>' +
      // tslint:disable-next-line:max-line-length
      '<a class="btn btn-success btn-bh-feedback">Send Feedback</a> &nbsp; <a href="' + this.supportLink + '" target="_blank" class="btn btn-info btn-support-log">Log Support Ticket</a>'
      } );

      jQuery('.btn-bh-feedback').click(function() {
        swal.close();
        _bugHerd.win.bugherd.applicationView.anonymousbar.toggleOptions();
      });

  }

  onChangeShare(el: any) {
    this.selected_share = el.target.value;

    if ( this.selected_share === 'offices' ) {
      setTimeout(() => {
        this.onShareToClient();
      }, 200);
    }

    if ( this.selected_share === 'subgroup' ) {
      setTimeout(() => {
        this.onShareToSubGroup();
      }, 200);
    }

    if ( this.selected_share === 'agent' ) {
      this.onShareToUser();
    }
  }

  onSaveCheck() {
    const $this = this;
    const data = [];
    let key_name = '';

    if ( this.selected_share === 'offices' || this.selected_share === 'subgroup' ) {
      key_name = 'client_id';
    }

    if ( this.selected_share === 'agent' ) {
      key_name = 'user_id';
    }

    $('#shareTo input:checked').each(function() {
      data.push({
        'template_id': $this._tmp_template.ID,
        [key_name]: $(this).val()
      });
    });

    const shareValues = {
      'template_id': this._tmp_template.ID,
      'records': data
    };

    this.templateService.httpShareTemplate(this.selected_share, shareValues);
    this.loading = true;
  }

  onScroll() {
    if ( this.templates.length < this.template_count ) {
      this.loading = true;
      this.offset += 1;

      const templateQuery = {
        user_agent_id: `${this.authUser.user.ID},${this.authUser.user.agent_id}`,
        client_id: this.authUser.client.ID,
        group_id: this.authUser.client.group_id,
        is_active: '1',
        offset: this.offset
      };

      if ( this.authUser.is_admin || this.authUser.client.group_id === 12 ) {
        delete templateQuery.user_agent_id;
      }

      this.templateService.httpGetTemplates(
        templateQuery,
        'dashboard',
        this.current_sort_by
      );
    }

  }

  onChangeSort(val) {
    this.current_sort_by = val;
    this.offset = 0;

    const templateQuery = <any> {
      user_agent_id: `${this.authUser.user.ID},${this.authUser.user.agent_id}`,
      client_id: this.authUser.client.ID,
      group_id: this.authUser.client.group_id,
      is_active: '1',
      offset: this.offset
    };

    if ( this.authUser.is_admin || this.authUser.client.group_id === 12 ) {
      delete templateQuery.user_agent_id;
    }

    if ( this.current_template_filter !== '' && this.current_template_filter !== 'all' ) {
      templateQuery.category_id = this.current_template_filter;
    } else {
      delete templateQuery.category_id;
    }

    if ( this.current_agent_filter !== '' && this.current_agent_filter !== 'all' ) {
      templateQuery.user_agent_id = this.current_agent_filter;
    } else {
      delete templateQuery.user_agent_id;
    }


    this.templateService.httpGetTemplates(
      templateQuery,
      'dashboard',
      this.current_sort_by
    );
  }

  onChangeTemplateFilter(val) {
    this.current_template_filter = val;
    this.offset = 0;

    const templateQuery = {
      user_agent_id: `${this.authUser.user.ID},${this.authUser.user.agent_id}`,
      client_id: this.authUser.client.ID,
      group_id: this.authUser.client.group_id,
      is_active: '1',
      offset: this.offset,
      category_id: val
    };

    if ( this.authUser.is_admin || this.authUser.client.group_id === 12 ) {
      delete templateQuery.user_agent_id;
    }

    if ( val === 'all' ) {
      delete templateQuery.category_id;
    }

    if ( this.current_agent_filter !== '' && this.current_agent_filter !== 'all' ) {
      templateQuery.user_agent_id = this.current_agent_filter;
    }

    this.templateService.httpGetTemplates(
      templateQuery,
      'dashboard',
      this.current_sort_by
    );
  }

  onChangeAgentFilter(val) {
    this.current_agent_filter = val;
    this.offset = 0;

    const templateQuery = <any> {
      user_agent_id: `${this.authUser.user.ID},${this.authUser.user.agent_id}`,
      client_id: this.authUser.client.ID,
      group_id: this.authUser.client.group_id,
      is_active: '1',
      offset: this.offset
    };

    if ( this.authUser.is_admin || this.authUser.client.group_id === 12 ) {
      delete templateQuery.user_agent_id;
    }

    if ( val === 'all' ) {
      delete templateQuery.user_agent_id;
    } else {
      templateQuery.user_agent_id = val;
    }

    if ( this.current_template_filter !== '' && this.current_template_filter !== 'all' ) {
      templateQuery.category_id = this.current_template_filter;
    }

    this.templateService.httpGetTemplates(
      templateQuery,
      'dashboard',
      this.current_sort_by
    );
  }

  onClickSend(link, val) {
    if ( link !== 'secure' ) {
      window.location.href = 'http://' + link + '.' + val;
    } else {
      swal({
        title: 'I am signed in via',
        type: 'info',
        html:
          // tslint:disable-next-line:max-line-length
          '<a href="http://login.' + val + '" target="_blank" class="btn btn-primary">MyDesktop</a> &nbsp; <a href="http://secure.' + val + '" target="_blank" class="btn btn-info">Domain Group</a>',
        showCancelButton: false,
        showConfirmButton: false,
        focusConfirm: false
      });
    }
  }

  onSearchKeyUp() {
    if ( !this.isFetchedAlready ) {
      this.isFetchedAlready = true;

      setTimeout(() => {
        this.isFetchedAlready = false;

        this.offset = 0;

        const templateQuery = <any> {
          user_agent_id: `${this.authUser.user.ID},${this.authUser.user.agent_id}`,
          client_id: this.authUser.client.ID,
          group_id: this.authUser.client.group_id,
          is_active: '1',
          offset: this.offset,
          keyword: this.term
        };

        if ( this.authUser.is_admin || this.authUser.client.group_id === 12 ) {
          delete templateQuery.user_agent_id;
        }

        this.templateService.httpGetTemplates(
          templateQuery,
          'dashboard',
          this.current_sort_by
        );
      }, 2000);
    }
  }

  openMenu(type, template) {
    this.type = type;
    this.template = template;
    if ( this.template.category.slug === 'enewsletter'
      || this.template.category.slug === 'quick-enquiry' ||
      this.template.category.slug === 'email-signature' ) {
        $('.btn-send').removeClass('hidden');
      } else {
        $('.btn-send').addClass('hidden');
      }
  }

  ngAfterViewInit() {
    if ( this.authUser.user.partica_popup === 0
      && localStorage.getItem('tmp_partica_popup_disabled') !== 'yes'
      && this.authUser.provider === 'mydesktop' ) {
      $('#articleModal').modal('show');
    }
  }

  generateCampaign() {
    this.campaignService.httpBuildTemplates(this.listing);
    this.loading = true;
  }

  exportCampaign() {
    this.campaignService.httpExportCampaign(this.listing.campaign_id);
    this.loading = true;
  }

  getTemplates() {
    this.campaignService.listing = this.listing;
    this.campaignService.httpGenerateCampaignTemplates(this.listing);
    this.loading = true;
  }

  removeFromCampaign(template) {
    console.log(template);
    const $this = this;
    swal({
      title: 'Are you sure you want to remove this template on this campaign?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Remove'
    }).then(function () {
      $this.loading = true;
      swal(
        'Removed!',
        'Your template has been removed from this campaign.',
        'success'
      );
      $this.ID = template.ID;

      $this.campaignService.httpRemoveListingFromCampaign($this.listing.campaign_id, template.parent_id, template.ID);
    });
  }

  addTemplateToCampaign(templateId) {
    this.templateId = templateId;

    this.campaignService.httpGetCampaigns({
      type: 'custom'
    });
    this.loading = true;
  }

  onaddTemplate() {
    const templateFormValues = this.campaignTemplateForm.value;

    templateFormValues['client_id'] = this.authUser.client.ID;
    templateFormValues['group_id'] = this.authUser.client.group_id;
    templateFormValues['user_id'] = this.authUser.user.ID;
    templateFormValues['template_id'] = this.templateId;

    this.campaignService.httpPostCampaignTemplate(templateFormValues);
    this.loading  = true;
  }

  refreshTemplates() {
    this.loading = true;
    this.templateService.httpRefreshTemplates(this.listing.campaign_id);
  }

  goToEdit(templateId) {
    return this.router.navigateByUrl(`/templates/${templateId}/build`);
  }

}



// WEBPACK FOOTER //
// ./src/app/front/templates-front/template-front-dashboard/template-front-dashboard.component.ts